import './App.css';
import NavBar from './Components/NavBar';
import Home from'./Components/Home';

function App() {
  return (
    <div className="App">
     <NavBar />
     <Home />
    </div>
  );
}

export default App;
